import styled from 'styled-components';
import colors from 'theme/colors';
import devices from 'theme/devices';
import { Group, Stack } from 'ui';

export const TabContentWrap = styled(Stack)<{ isFullscreen: boolean }>`
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  overflow-y: auto;
  gap: 1rem;
  padding 0 1rem 1rem;
  display: grid;
  grid-auto-rows: min-content;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  ${(props) =>
    props.isFullscreen &&
    `
    @media screen and ${devices.tablet} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media screen and ${devices.laptop} {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  `}
`;

export const NoItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  font-size: 18px;
`;

export const Form = styled.form`
  height: 100%;
  display: flex;
  gap: 25px;
  justify-content: space-between;
  flex-direction: column;
`;

export const FilePreview = styled(Group)`
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid ${colors.blue};
`;

export const ContributorForm = styled.form`
  height: 100%;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  flex-direction: column;

  .react-select__dropdown-indicator {
    display: none;
  }
  .react-select__placeholder {
    max-width: 100%;
  }

  .react-select__control {
    width: 100%;
    padding-left: 40px;
  }
`;

export const InputWrap = styled.div`
  position: relative;
`;

export const SearchWrap = styled.i`
  position: absolute;
  left: 17px;
  top: 11px;
  z-index: 1;
`;

export const AddTagsModal = styled.form`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: 380px;
  padding: 12px 10px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 7px 29px 0px;
  border-radius: 6px;
  background-color: ${colors.dark2};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  @media screen and ${devices.laptop} {
    left: 16px;
    transform: translateX(0%);
    width: 366px;
  }
`;

export const AddReferenceIntegrationWarningContainer = styled(Group)`
  margin-top: 16px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.blue};
  background-color: ${({ theme }) => theme.colors.dark2};
`;
